import { render } from "./Multiselect.vue?vue&type=template&id=135c729e"
import script from "./Multiselect.vue?vue&type=script&lang=js"
export * from "./Multiselect.vue?vue&type=script&lang=js"

import exportComponent from "C:\\VS2022\\kirchenbote-online-2022_01\\MD.RMP.KirchenboteOnline.Umb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/multiForms/fieldTypes/Multiselect.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "135c729e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('135c729e', __exports__)) {
    api.reload('135c729e', __exports__)
  }
  
  module.hot.accept("./Multiselect.vue?vue&type=template&id=135c729e", () => {
    api.rerender('135c729e', render)
  })

}


export default __exports__